export const imageUrlPrefix = `${process.env.GATSBY_IMAGE_URL_PREFIX}`;
